import { Injectable } from '@angular/core';

import { map, Observable, of } from 'rxjs';

import { IdentityReferenceItem } from '@reg/shared/model';
import { HttpServiceHelper } from '@reg/shared/service';
import { IJsonApiResponse } from '@reg/shared/json-api/json-api.interface';
import { observableInSeparateThread } from '@reg/shared/helper/observable-helper';

/**
 * Service for referenceItem data.
 */
@Injectable()
export class IdentityReferenceItemService {
    private identityApiBaseUrl: string;
    private cachedItemsMap: { [apiRequest: string]: IdentityReferenceItem[]; } = {};

    /**
     * Constructor
     */
    constructor(private http: HttpServiceHelper) {
        this.identityApiBaseUrl = http.configService.getBaseConfig('identityApiBaseUrl');
    }

    /**
     * Get a referenceItems
     */
    public getIndex<T>(instanceOfName: string, includeDeleted: boolean = false): Observable<IdentityReferenceItem[]> {
        const queryParams: string[] = [
            `instanceOf=${instanceOfName}`,
            `includeDeleted=${includeDeleted}`,
        ];

        const apiRequestUrl: string = this.getApiUrl(null, null, queryParams);

        if (this.cachedItemsMap[apiRequestUrl]) {
            // if cache is available just return it as `Observable`
            return observableInSeparateThread(
                this.cachedItemsMap[apiRequestUrl].map((a: any) => a.clone()),
            );
        }
        // Make the http request
        return this.http.get(apiRequestUrl)
            .pipe(map((response: IJsonApiResponse) => {
                const referenceItems: IdentityReferenceItem[] = [];

                const bodyData: any = response.data || [];
                for (const referenceItem of bodyData) {
                    referenceItems.push((new IdentityReferenceItem()).deserialize(referenceItem));
                }

                this.cachedItemsMap[apiRequestUrl] = referenceItems;
                return referenceItems.map((referenceItem: IdentityReferenceItem) => referenceItem.clone());
            }));
    }

    /**
     * Build the api's url based on the given parameters
     */
    private getApiUrl(assessorId: string, includes: string[] = null, queryParams: string[] = null): string {
        let url: string = `${this.identityApiBaseUrl}/reference-items/`;

        if (assessorId) {
            url += assessorId;
        }

        url += this.http.getQueryParameters(includes, queryParams);

        return url;
    }
}
